module.exports = __webpack_public_path__ + "static/assets/7a21cbe90fd31540fb0384792fbc4a86.svg";